import { observer, useTranslation } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as UsePageTrackingModule from "../hooks/usePageTracking.js";
import * as React from "react";
import { CustomCursor } from "../components/CustomCursor.jsx";
import * as SiteState from "../state/siteStore.js";
import { DesktopNav } from "../components/navigation/DesktopNav.jsx";
import { MobileNav } from "../components/navigation/MobileNav.jsx";
import { Hero } from "../components/hero/Hero.jsx";
import { AiNews } from "../components/sections/AiNews.jsx";
// import { Updates } from "../components/sections/Updates.jsx"; // temporarily disabled
import { Models } from "../components/sections/Models.jsx";
import { Products } from "../components/sections/Products.jsx";
import { Ecosystem } from "../components/sections/Ecosystem.jsx";
import { DeveloperVoices } from "../components/sections/DeveloperVoices.jsx";
import { About } from "../components/sections/About.jsx";
var HomePage = observer(function () {
  let { i18n: i18n } = useTranslation(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    i = i18n.language?.startsWith("zh");
  return (
    (0, UsePageTrackingModule.usePageTracking)(track, "home_view", undefined, {
      reportOnUnmount: true,
      reportOnBeforeUnload: true,
    }),
    (0, React.useEffect)(
      () => (
        document.body.classList.toggle("lang-zh", i),
        () => {
          document.body.classList.remove("lang-zh");
        }
      ),
      [i],
    ),
    (
      <div className={`Home_homePage__0iuvX ${i ? "lang-zh" : ""}`}>
        <div id={"hero-portal"} className={"Home_heroPortal__0iuvX"} />
        <CustomCursor />
        <div
          data-home-nav={true}
          className={`Home_homeNav__0iuvX ${SiteState.siteStore.showBanner ? "Home_withBanner__0iuvX" : ""}`}
        >
          <DesktopNav />
          <MobileNav />
        </div>
        <Hero />
        <div className={"Home_homePageInner__0iuvX"}>
          {/* Updates temporarily disabled, replaced by AiNews */}
          <AiNews />
          <Models />
          <Products />
          <Ecosystem />
          {/* <DeveloperVoices /> */}
          <About />
        </div>
      </div>
    )
  );
});
export { HomePage };
